import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { gameSounds } from "@/lib/gameSounds";

// Site-wide arcade SFX: soft blip on button/link clicks, whoosh on route change.
export const SiteSfx = () => {
  const location = useLocation();
  const firstRoute = useRef(true);

  useEffect(() => {
    const onClick = (e) => {
      const el = e.target.closest("button, a, [role='button']");
      if (!el) return;
      gameSounds.blip(1150, 1750, 0.055, "square", 0.028);
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  useEffect(() => {
    if (firstRoute.current) {
      firstRoute.current = false;
      return;
    }
    gameSounds.blip(300, 980, 0.16, "triangle", 0.05);
  }, [location.pathname]);

  return null;
};

export default SiteSfx;
